import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchDashboard = (userId) => {
  const url = DepsService.rest.dashboard.data.url;
  const queryParams = {};
  const urlParams = { userId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchDefaultDashboard = (type) => {
  const url = DepsService.rest.dashboard.defaults.url;
  const queryParams = {};
  const urlParams = { type };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const updateDashboard = (dashboardToSave) => {
  const url = DepsService.rest.dashboard.save.url;
  const queryParams = dashboardToSave;
  const urlParams = {
    dashboardId: dashboardToSave.id,
  };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/dashboard.api.js